module.exports = __webpack_public_path__ + "img/avatar.90da0c22.png";